export const ACCOMMODATION_TITLE = 'Accommodation'
